var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import lodash from 'lodash';
import { observer } from 'mobx-vue';
import { Component, Vue } from 'vue-property-decorator';
let default_1 = class extends Vue {
    get User() {
        return this.$Store.System.User;
    }
    get version() {
        return `V ${this.AppConfig.version}`;
    }
    get timestamp() {
        return this.AppConfig.timestamp;
    }
    get showVersion() {
        return !this.AppConfig.release;
    }
    stringify(value) {
        return JSON.stringify(value, null, 4);
    }
    async onBlur(event) {
        try {
            const value = JSON.parse(lodash.get(event, 'target.value'));
            if (lodash.isEqual(value, this.User.value)) {
                return;
            }
            await this.AppConfig.onClear();
            this.User.merge(value);
            this.$notification.open({
                message: '用户信息更新',
                description: '是否刷新页面？',
                btn: (h) => {
                    return h('a-button', {
                        props: {
                            type: 'primary',
                            size: 'small',
                        },
                        on: {
                            click: () => window.location.reload(),
                        },
                    }, 'Confirm');
                },
            });
        }
        catch (error) {
            this.$notification.warning({
                message: '提示',
                description: '无法格式化json',
            });
        }
    }
    mounted() { }
    updated() { }
    destroyed() { }
};
default_1 = __decorate([
    observer,
    Component({
        components: {},
    })
], default_1);
export default default_1;
